module.exports = __webpack_public_path__ + "img/no-comments.94037637.png";